export interface SolfegeMemeTemplate {
  title: string;
  text: string;
  solfege: string;
  textFontSize: number;
  solfegeFontSize: number;
  lineSpacing: number;
  backgroundColor: 'red' | 'green' | 'blue' | 'orange' | 'slate';
}

export const solfegeMemeTemplates: SolfegeMemeTemplate[] = [
  {
    title: 'Happy Birthday',
    text: `Happy Birthday!`,
    textFontSize: 41,
    solfege: `ssls+dt
ssls+rd
ss+smdtl
+ffmdrd
`,
    solfegeFontSize: 59,
    lineSpacing: 0.75,
    backgroundColor: 'blue',
  },
  {
    title: 'May 4th',
    text: 'May the 4th Be With You',
    textFontSize: 65,
    solfege: `-SSSD+S
FMR+DS
FMR+DS
FMFR`,
    solfegeFontSize: 55,
    lineSpacing: 0.43,
    backgroundColor: 'slate',
  },
  {
    title: "Rick-Rollin'",
    text: `Rick-Rollin'`,
    textFontSize: 60,
    solfege: `SL+DL+MMR
SL+DL+RRD
SL+DL+DRT
SS+RD`,
    solfegeFontSize: 59,
    lineSpacing: 0.77,
    backgroundColor: 'orange',
  },
  {
    title: 'Merry Christmas',
    text: `Merry Christmas!`,
    textFontSize: 41,
    solfege: `SLSM SLSM
+RRT DDS
LL+DTLSLSM
LL+DTLSLSM
+RRFRTDM
D-SMSFRD`,
    solfegeFontSize: 45,
    lineSpacing: 0.59,
    backgroundColor: 'red',
  },
  {
    title: 'Shabbat Shalom',
    text: `Shabbat Shalom!`,
    textFontSize: 52,
    solfege: `LLLL
LLRD
TLTD
TLL`,
    solfegeFontSize: 64,
    lineSpacing: 0.64,
    backgroundColor: 'blue',
  },
  {
    title: 'Happy Pride',
    text: 'Happy Pride!',
    textFontSize: 52,
    solfege: `MSMSMS
L S LS
MSMSMRD
R D RD-L`,
    solfegeFontSize: 59,
    lineSpacing: 0.79,
    backgroundColor: 'orange',
  },
  {
    title: 'Name that tune',
    text: 'Name that tune!',
    textFontSize: 52,
    solfege: '',
    solfegeFontSize: 45,
    lineSpacing: 0.4,
    backgroundColor: 'blue',
  },
  {
    title: 'Custom',
    text: '',
    textFontSize: 52,
    solfege: '',
    solfegeFontSize: 45,
    lineSpacing: 0.4,
    backgroundColor: 'blue',
  },
];
